import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserComponent } from './user.component';
import { UserListComponent } from './user-list.component';

const routes: Routes = [
    { path: 'users', component: UserListComponent },
    { path: 'users/:id', component: UserComponent },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonModule

    ],
    declarations: [
        ],
    exports: [
        RouterModule
    ]
})
export class UsersRoutingModule { }

export const routedUsersComponents = [UserListComponent, UserComponent];  
